import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TextareaModule } from 'primeng/textarea';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

export const PRIMENG_ROOT_MODULE = [
	AccordionModule,
	AutoCompleteModule,
	AvatarModule,
	AvatarGroupModule,
	BadgeModule,
	BreadcrumbModule,
	ButtonModule,
	DatePickerModule,
	CardModule,
	CarouselModule,
	CascadeSelectModule,
	ChartModule,
	CheckboxModule,
	ChipModule,
	ConfirmDialogModule,
	ConfirmPopupModule,
	ColorPickerModule,
	ContextMenuModule,
	DataViewModule,
	DialogModule,
	DividerModule,
	SelectModule,
	FieldsetModule,
	FileUploadModule,
	GalleriaModule,
	InplaceModule,
	InputNumberModule,
	InputMaskModule,
	ToggleSwitchModule,
	InputTextModule,
	TextareaModule,
	KnobModule,
	ListboxModule,
	MegaMenuModule,
	MenuModule,
	MenubarModule,
	MessageModule,
	MultiSelectModule,
	OrderListModule,
	OrganizationChartModule,
	PopoverModule,
	PaginatorModule,
	PanelModule,
	PanelMenuModule,
	PasswordModule,
	PickListModule,
	ProgressBarModule,
	RadioButtonModule,
	RatingModule,
	RippleModule,
	ScrollPanelModule,
	ScrollTopModule,
	SelectButtonModule,
	DrawerModule,
	SkeletonModule,
	SliderModule,
	SplitButtonModule,
	SplitterModule,
	StepsModule,
	StyleClassModule,
	TableModule,
	TagModule,
	TerminalModule,
	TimelineModule,
	TieredMenuModule,
	ToastModule,
	ToggleButtonModule,
	ToolbarModule,
	TooltipModule,
	TreeModule,
	TreeTableModule,
	DynamicDialogModule,
];
